import { IS_PROD } from '../../utils/constants/env';

export const RECAPTCHA_SITE_KEY_WEB = IS_PROD
  ? '6LeKBnokAAAAAO1iU5R7414d9BiAXl8i9IsL7MM1'
  : '6LfaMIkkAAAAAMggzPhB7F_NsyFDXwhVVAN7618K';
